module.exports = __webpack_public_path__ + "img/icon_paper.3b32911d.png";